

export function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export function calculateProperCenteredPolygonCoords(northEast, mapCenterLocation){

    return [
        {lat:  mapCenterLocation.lat - (northEast.lat() -  mapCenterLocation.lat) / 3, lng: mapCenterLocation.lng - (northEast.lng() - mapCenterLocation.lng) / 4},
        {lat: mapCenterLocation.lat - (northEast.lat() -  mapCenterLocation.lat) / 3, lng: mapCenterLocation.lng + (northEast.lng() - mapCenterLocation.lng) / 4},
        {lat: mapCenterLocation.lat + (northEast.lat() -  mapCenterLocation.lat) / 3, lng: mapCenterLocation.lng + (northEast.lng() - mapCenterLocation.lng) / 4},
        {lat: mapCenterLocation.lat + (northEast.lat() -  mapCenterLocation.lat) / 3, lng: mapCenterLocation.lng - (northEast.lng() - mapCenterLocation.lng) / 4},
        {lat:  mapCenterLocation.lat - (northEast.lat() -  mapCenterLocation.lat) / 3, lng: mapCenterLocation.lng - (northEast.lng() - mapCenterLocation.lng) / 4}

    ]
}

export function calculateProperCenteredNoFlyPolygonCoords(northEast, mapCenterLocation){
    return [
        {lat:  mapCenterLocation.lat - (northEast.lat() -  mapCenterLocation.lat) / 8.8, lng: mapCenterLocation.lng - (northEast.lng() - mapCenterLocation.lng) / 9.8},
        {lat: mapCenterLocation.lat - (northEast.lat() -  mapCenterLocation.lat) / 8.8, lng: mapCenterLocation.lng + (northEast.lng() - mapCenterLocation.lng) / 9.8},
        {lat: mapCenterLocation.lat + (northEast.lat() -  mapCenterLocation.lat) / 8.8, lng: mapCenterLocation.lng + (northEast.lng() - mapCenterLocation.lng) / 9.8},
        {lat: mapCenterLocation.lat + (northEast.lat() -  mapCenterLocation.lat) / 8.8, lng: mapCenterLocation.lng - (northEast.lng() - mapCenterLocation.lng) / 9.8},

    ]
}

export function getCentroidAreaCoverage(areaOfInterest) {

    if(areaOfInterest && areaOfInterest.length > 0) {

        let centroid = areaOfInterest.reduce((acc, curr) => {
            return {lat: acc.lat + curr.lat, lng: acc.lng + curr.lng}
        }, {lat: 0, lng: 0})
        centroid.lat = centroid.lat / areaOfInterest.length;
        centroid.lng = centroid.lng / areaOfInterest.length;
        return centroid;
    }
}

export function getCentroidScatteredRegionsOfInterest(scatteredRegionsOfInterest) {

    if(scatteredRegionsOfInterest && scatteredRegionsOfInterest.length > 0) {
        let centroids = []

        scatteredRegionsOfInterest.forEach(polygon => {
            let centroid = polygon.reduce((acc, curr) => {
                return {lat: acc.lat + curr.lat, lng: acc.lng + curr.lng}
            }, {lat: 0, lng: 0})
            centroid.lat = centroid.lat / polygon.length;
            centroid.lng = centroid.lng / polygon.length;
            centroids.push(centroid);
        })

        let finalcentroid = centroids.reduce((acc, curr) => {
            return {lat: acc.lat + curr.lat, lng: acc.lng + curr.lng}
        }, {lat: 0, lng: 0})
        finalcentroid.lat = finalcentroid.lat / centroids.length;
        finalcentroid.lng = finalcentroid.lng / centroids.length;
        return finalcentroid;
    }


}

// DJI Phantom 4 Pro
const HFOV = 73.4;
const hRes = 5472;

// DJI Mavic 2 Enterprise Dual (RGB)
// const HFOV = 84;
// const hRes = 8000;

// DJI Mavic 2 Enterprise Dual (IR)
// const HFOV = 49.45;
// const hRes = 640;

// MicaSense RedEdge-MX
// const HFOV = 47.2;
// const hRes = 1280;


export function gsd(altitude) {
    return ((2 * altitude * getTanFromDegrees(HFOV / 2)) / hRes) * 100
}

function getTanFromDegrees(degrees) {
    return Math.tan(degrees * Math.PI / 180);
}

function covered(altitude) {

    return 2 * altitude * getTanFromDegrees(HFOV / 2)
}

export function computeScanningDensity(altitude, percentageOfSidelap) {
    return (covered(altitude) * (1 - percentageOfSidelap / 100));
}

export function computeVerticalSpeed(droneConfig, droneType, horizontalSpeed) {

    let drone = droneConfig.find(c => c.type === droneType)
    return Math.min(horizontalSpeed, drone.verticalMaxSpeed)
}
